// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1MLMC","expireSoon":"styles_expireSoon__3M-DL"};